import { Button } from "@mui/material";
import React from "react";
import { DefaultDialogProps } from "../../../components/default-dialog";
import DefaultDrawer from "../../../components/default-drawer";
import { useBaseLayoutController } from "../../../base-layout/context/base-layout-controller";
import SaveIcon from '@mui/icons-material/Save';
import { useConveniosState } from "../context/convenios-context";
import { useConveniosController } from "../context/convenios-controller";
import { ConvenioForm } from "./convenio-form";

export const ConvenioDrawer = () => {
    const { showDialog } = useBaseLayoutController();
    const { save, closeForm } = useConveniosController();
    const { dataResponse, showAddEdit } = useConveniosState();

    const getTitle = (): string => {
        if (dataResponse !== undefined && dataResponse !== null && dataResponse?.id !== null)
            return `Editar Convênio ${dataResponse?.id}`;
        return "Adicionar Convênio";
    };

    return (
        <DefaultDrawer isOpen={showAddEdit} title={getTitle()} onClose={closeForm}
            actions={() => (
                <Button variant="contained" endIcon={<SaveIcon />} onClick={() => {
                    showDialog({
                        open: true,
                        message: "Deseja realmente salvar essa informação?",
                        onYesClick: () => {
                            (async () => {
                                await save();
                            })();
                        }
                    } as DefaultDialogProps);
                }}>
                    Salvar
                </Button>
            )}>
            <ConvenioForm />
        </DefaultDrawer>
    );
};
